import React from 'react';
import PropTypes from 'prop-types';
// import { connect } from 'dva';
import Button from '../../Button';
import styles from './UserPlanModal.module.scss';
import gohuntLogo from '../../../assets/img/logo_maps_2x.png';
import { connect } from 'react-redux';
import X from '../../../assets/svg/Feather/X';
// import ChevronRight from '../../../assets/svg/Feather/ChevronRight';

function UserPlanModal(props) {

  const closeModal = () => {
    props.dispatch({
      type: 'modals/close'
    });
  };

  return (
   <div className={styles.fadeIn}>
     <div className={styles.container}>
      {props.dismissable ? (
        <button className={styles.closeButton} onClick={closeModal}>
          <X width={24} color='#939393' />
        </button>
      ) : null}
      <div className={styles.gohuntLogoContainer}>
          <img
            className={styles.gohuntLogo}
            src={gohuntLogo}
            width={80}
            height={80}
          />
        </div>
      <h1 className={styles.title}>{props.title}</h1>
      <h2 className={styles.subtitle}>{props.subtitle}</h2>
      <h3 className={styles.text}>{props.text}</h3>
      <div className={styles.actionButtons}>
        {props.actionItems.map((actionItem, index) => {
          return (
            <Button
              className={actionItem.className || styles.actionItem}
              key={index}
              onClick={actionItem.onClick}
              size={Button.SIZE.medium}
              theme={actionItem.theme || Button.THEME.orange}
            >
              {actionItem.title}
            </Button>
          );
        })}
      </div>
    </div>
   </div>
  );
}

UserPlanModal.propTypes = {
  actionItems: PropTypes.array,
  dismissable: PropTypes.bool,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string
};

UserPlanModal.defaultProps = {
  dismissable: false
};


export default connect(() => ({}))(UserPlanModal);